
    import I18n from 'i18nObj';
    
      import 'translations/new_nav';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('new_nav');
  